import { render, staticRenderFns } from "./RegisterInfomation.vue?vue&type=template&id=34135c83&scoped=true"
import script from "./RegisterInfomation.vue?vue&type=script&lang=js"
export * from "./RegisterInfomation.vue?vue&type=script&lang=js"
import style0 from "./RegisterInfomation.vue?vue&type=style&index=0&id=34135c83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34135c83",
  null
  
)

export default component.exports